
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import ImagesModule from '@/store/images';
import DirectoriesModule from '@/store/directories';
import {getById} from "@/api/crud";
import {API_URL} from "@/utils/constants";

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class ImagesPage extends Vue {
    repository = ImagesModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    async download(row: any) {
        const info = await getById('images', row.id)
        const link = document.createElement('a');
        link.href = API_URL + 'api/images/download/' + info.image.src;
        link.target = '_blank';
        link.click();
    }
}
